export const passwordRegex: {
    medium: RegExp;
    strong: RegExp;
} = {
  medium: new RegExp("^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[^A-Za-z0-9]).{8,}$"),
  strong: new RegExp(
    "^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[^A-Za-z0-9]).{8,}$"
  ),
};
